import isObjectEmpty from '../../helpers/isObjectEmpty';
import StorageService from './StorageService';

const constructUrl = (apiBaseURL, apiPrefix, urlSegments = []) => {
  let api_constructed_url = apiBaseURL + '/';
  if (apiPrefix !== 'none') {
    api_constructed_url += apiPrefix + '/';
  }
  if (urlSegments.length > 1) urlSegments[0] = urlSegments[0].replace(/\/$/, '');
  const compositeUrl = urlSegments.length > 1 ? urlSegments.join('/') : urlSegments[0];
  return api_constructed_url.concat(compositeUrl);
};

const constructQueryParams = data => {
  return !isObjectEmpty(data)
    ? '?'.concat(
        Object.keys(data)
          .map(key => `${key}=${data[key] ? data[key] : ''}`)
          .join('&')
      )
    : '';
};

const constructHeaders = (contentType, isAuthRequired, extraHeaders) => {
  let headers = {};
  if (process.env.ENV !== 'staging') {
    headers = {
      remote_user: process.env.REMOTE_USER,
    };
  }
  const token = StorageService.getFromSession('token');

  if (!!token) {
    headers = Object.assign(headers, {
      Authorization: `Bearer ${StorageService.getFromSession('token')}`,
    });
  }

  if (isAuthRequired) {
    return Object.assign(headers, {
      'Content-Type': contentType,
    });
  } else {
    return Object.assign(headers, {
      'Content-Type': contentType,
      'X-Auth-Token': StorageService.get('DTM-CLIENT-TOKEN'),
    });
  }
};

const constructBody = (data, contentType) => {
  return contentType === 'application/json;charset=utf-8' ? JSON.stringify(data) : data;
};

export const sendGET = (
  apiBaseURL,
  apiPrefix,
  urlSegments,
  params = {},
  isAuthRequired,
  extraHeaders = {},
  contentType = 'application/json;charset=utf-8'
) => {
  return fetch(constructUrl(apiBaseURL, apiPrefix, urlSegments).concat(constructQueryParams(params)), {
    method: 'GET',
    headers: constructHeaders(contentType, isAuthRequired, extraHeaders),
  });
};

export const sendPOST = (
  apiBaseURL,
  apiPrefix,
  urlSegments,
  data = [],
  params = {},
  isAuthRequired,
  contentType = 'application/json;charset=utf-8'
) => {
  return fetch(constructUrl(apiBaseURL, apiPrefix, urlSegments).concat(constructQueryParams(params)), {
    method: 'POST',
    headers: constructHeaders(contentType, isAuthRequired),
    body: constructBody(data, contentType),
  });
};

export const sendPUT = (apiBaseURL, apiPrefix, urlSegments, data, contentType = 'application/json;charset=utf-8') => {
  return fetch(constructUrl(apiBaseURL, apiPrefix, urlSegments), {
    method: 'PUT',
    headers: constructHeaders(contentType),
    body: constructBody(data, contentType),
  });
};

export const sendDELETE = (
  apiBaseURL,
  apiPrefix,
  urlSegments,
  params = {},
  contentType = 'application/json;charset=utf-8'
) => {
  return fetch(constructUrl(apiBaseURL, apiPrefix, urlSegments).concat(constructQueryParams(params)), {
    method: 'DELETE',
    headers: constructHeaders(contentType),
  });
};
